import { call, put } from '@redux-saga/core/effects'
import axios from 'axios'
import { Action } from '../../../../common/store/sagas/root'
import { hipUserDetail } from '../../../api/hipUserDetail'
import { User } from '../../../../types'
import { hip_userDetailError, hip_userDetailSuccess } from '../../../actions/hipUsers/actions'

export function* sagaUserDetail({ payload }: Action<number>) {
  try {
    const response: User = yield call(hipUserDetail, payload)
    yield put(hip_userDetailSuccess(response))
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      yield put(hip_userDetailError(error.response.data as unknown))
    } else {
      yield put(hip_userDetailError(error))
      throw error
    }
  }
}
